import { useState, useRef, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../../components/tailwind-component/ui/tabs';
import { AutomationList } from './ig-dm-automations/AutomationList';
import { ActivityLog } from './ig-dm-automations/ActivityLog';
import { AccountSettings } from './ig-dm-automations/AccountSettings';
import { SetupWizard } from './ig-dm-automations/SetupWizard';
import { StepScope } from './ig-dm-automations/wizard/StepScope';
import { Instagram, Zap, Activity, Settings, CheckCircle2, PlayCircle, ChevronLeft } from 'lucide-react';
// import { Button } from './ui/button';
import './ig-dm-automations/styles/globals.css';
import './ig-dm-automations/index.css';
import { connect } from 'react-redux';
import { Loading, UserLogin } from "../../../../redux/action";
import * as gtUtil from "../../../../core/utility";
import { InstagramDMAutomation } from "../../../../core/services/dm-automation-instagram.service";
import { toast } from 'react-toastify';
import ContentLoading from "../../../../components/loader/loading";
import { UserService } from "../../../../core/services";
import CommonPopUpCentered from "../../../../components/popup/common-popup-centered";
import { HandlesService } from '../../../../core/services/handles.service';
import { ExistingIgAutomation, PostWithAutomationMeta, IgAutomationSelectedPost, IgAutomationPopUps, AutomationContentType, AutomationScope, ZapTopTabsType, ZapDasboardTabsType, CurrentPlan } from 'custom-type';
import InstagramIcon from '../../../../components/icons/instagram-icon';
import InstagramIcon1 from '../../../../components/icons/instagram-icon1';
// import { useSearchParams } from "react-router-dom";
import { SubscriptionService } from '../../../../core/services';
import { useNavigate } from "react-router-dom";
import CommonModalClosable from '../../../../components/popup/common-modal-closable';
import ZapTourModal from './ZapTourModal';
import { UPGRADE_BENEFITS } from './upgradeBenefits';
import PlanLimitModal from './PlanLimitModal';
import useBodyClass from '../../../../hooks/useBodyClass';
import MobileConfirmPopup from '../../../../components/confirm-popup/confirm-popup-mobile';
import ZapMobileHeader from '../../../../components/mobile/ZapMobileHeader';
import { zapPaths } from './zapPaths';
import zapIconActive from '../../../../assets/images/zapIconActive.svg';


const instagramDMAutomationService: InstagramDMAutomation = new InstagramDMAutomation();
const handlesService = new HandlesService();
const userService = new UserService();
const subscriptionService: SubscriptionService = new SubscriptionService();

interface Props {
  loading: (data: any) => any;
  UserReducer: any;
  updateUser: any;
}

const ClanZap: React.FC<Props> = (props: Props) => {
  const navigate = useNavigate();
  // Brands use this page too (/brand/zap/automations) — see zapPaths.
  const { subscription: subscriptionPath, back: zapBackPath } = zapPaths();
  const [contentType, setContentType] = useState<AutomationContentType>(null);
  const [scope, setScope] = useState<AutomationScope>(null);

  const [topTab, setTopTab] = useState<ZapTopTabsType>('create');

  // const [searchParams] = useSearchParams();

  const [showWizard, setShowWizard] = useState(false);
  const [editingAutomation, setEditingAutomation] = useState<ExistingIgAutomation | null>(null);

  const [deleteAutomationLoading, setDeleteAutomationLoading] = useState<boolean>(false);
  const [popUps, setPopUps] = useState<IgAutomationPopUps>({
    openConnectInstagram: false,
    openPermissionMissingModal: false,
    openAdditionalSettingsModal: false,
    openAutomationDeleteConfirmation: false,
    openPostDeleteConfirmation: false,
    openUpgradeToAddMoreModal: false,
  });

  const [automations, setAutomations] = useState<ExistingIgAutomation[]>([]);
  const [selectedAutomation, setSelectedAutomation] = useState({
    automation_name: '',
    ig_automation_id: 0
  });

  // const [selectedPost, setSelectedPost] = useState({
  //   automation_name: '',
  //   ig_automation_id: 0,
  //   ig_automation_post_id: 0,
  //   thumbnail_url: '',
  //   media_url: '',
  //   permalink: '',
  // });

  const [selectedPost, setSelectedPost] = useState<IgAutomationSelectedPost>({
    automation_name: '',
    ig_automation_id: 0,
    ig_automation_post_id: 0,
    thumbnail_url: '',
    media_url: '',
    gcp_media_file_url: '',
    permalink: '',
  });

  // pagination states
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const loadMoreRef = useRef<HTMLDivElement | null>(null);
  const LIMIT = 5;
  // end pagination states
  const [activeTab, setActiveTab] = useState<ZapDasboardTabsType>("automations");
  const [totalAutomations, setTotalAutomations] = useState(0);
  const [activeAutomations, setActiveAutomations] = useState(0);
  // const [totalPosts, setTotalPosts] = useState(0);

  const [showActiveOnly, setShowActiveOnly] = useState(false);

  // ZAP Live is out of the internal-handles beta and open to everyone.
  // OLD (gated rollout — flip back to `true` and restore the INTERNAL_IG_HANDLES
  // check in getInfluencerAccounts below to re-restrict):
  // const [disableLive, setDisableLive] = useState(true);
  const [disableLive, setDisableLive] = useState(false);

  const [currentPlan, setCurrentPlan] = useState<CurrentPlan | null>(null);
  const [currentPlanName, setCurrentPlanName] = useState('');

  // For new Automation post restrictions based on current plan
  const [totalActiveAutomationPosts, setTotalActiveAutomationPosts] = useState(0);
  // The limit modal shown before the wizard, and the card the creator clicked
  // so Continue can resume exactly where they were headed.
  const [planLimitOpen, setPlanLimitOpen] = useState(false);
  const [pendingContentType, setPendingContentType] = useState<AutomationContentType | null>(null);
  const [maxActiveAutomationPosts, setMaxActiveAutomationPosts] = useState(0);
  const [allowOtherSource, setAllowOtherSource] = useState(true);

  // Upgrade Modal Content
  // const [upgrageToAddMoreModalContent, setUpgradeToAddMoreModalContent] = useState('Upgrade your plan to add more automations posts');
  const [upgrageToAddMoreModalContent, setUpgradeToAddMoreModalContent] = useState<React.ReactNode>('');
  const [howItWorksModalVisible, setHowItWorksModalVisible] = useState(false);
  const [zapTourVisible, setZapTourVisible] = useState(false);
  const handleDeleteAutomation = (id: number, name: string) => {
    setSelectedAutomation({
      automation_name: name,
      ig_automation_id: id
    });
    setPopUps({...popUps, openAutomationDeleteConfirmation: true});
  };

  const onPostDeletedRef = useRef<((postId: number) => void) | null>(null);

  const handleDeletePost = (post: PostWithAutomationMeta, onPostDeleted: (postId: number) => void) => {
    // setSelectedPost({
    //   automation_name: post.automation_name,
    //   ig_automation_id: post.ig_automation_id,
    //   ig_automation_post_id: post.ig_automation_post_id || 0,
    //   thumbnail_url: post.thumbnail_url,
    //   media_url: post.media_url,
    //   permalink: post.permalink,
    // });
    setSelectedPost({
      automation_name: post.automation_name,
      ig_automation_id: post.ig_automation_id,
      ig_automation_post_id: post.ig_automation_post_id || 0,
      thumbnail_url: post.thumbnail_url,
      media_url: post.media_url,
      gcp_media_file_url: post.gcp_media_file_url || '',
      permalink: post.permalink,
    });

    onPostDeletedRef.current = onPostDeleted; // STORE CALLBACK

    setPopUps({...popUps, openPostDeleteConfirmation: true});
  };

  async function deleteAutomationPost(ig_automation_id: number, ig_automation_post_id: number) {
    if (deleteAutomationLoading) return;
    setDeleteAutomationLoading(true);
    const response = await instagramDMAutomationService.igDeleteAutomationPost({
      ig_automation_id: ig_automation_id,
      ig_automation_post_id: ig_automation_post_id,
    });
    if (response.status === gtUtil.Constants.SUCCESS) {
      toast.success(response.info);

      onPostDeletedRef.current?.(ig_automation_post_id);
      // set_social_loader(false);
      handleClosePopUps();
    } else {
      setDeleteAutomationLoading(false);
      toast.error(response.info);
    }
  }

  async function deleteAutomation(ig_automation_id: number) {
    if (deleteAutomationLoading) return;
    setDeleteAutomationLoading(true);
    const response = await instagramDMAutomationService.igDeleteAutomation({
      ig_automation_id: ig_automation_id
    });

    if (response.status === gtUtil.Constants.SUCCESS) {
      toast.success(response.info);

      // refreshAutomationsList();
      // REMOVE ONLY THE DELETED AUTOMATION LOCALLY
      if (automations.length < LIMIT) {
        refreshAutomationsList();
      } else {
        setAutomations(prev =>
          prev.filter(
            automation => automation.ig_automation_id !== ig_automation_id
          )
        );
        setTotalAutomations(totalAutomations - 1);
      }

      // set_social_loader(false);
      handleClosePopUps();
    } else {
      setDeleteAutomationLoading(false);
      toast.error(response.info);
    }
  }

  const handleToggleAutomation = async(ig_automation_id: number, status: boolean, getActiveAutomations: boolean = false) => {
    // props.loading(true);
    const response = await instagramDMAutomationService.igOnOffAutomation({
      account_id: props.UserReducer.account_id,
      influencer_id: props.UserReducer.influencer_id,
      user_id: props.UserReducer.user_id,
      brand_id: props.UserReducer.brand_id || 0,
      user_type: 'Influencer',
      ig_automation_id: ig_automation_id,
      is_active: status,
    });
    if (response.status === gtUtil.Constants.SUCCESS) {
      toast.success(response.info);
      // refreshAutomationsList() // sync with server data
      // UPDATE ONLY THIS AUTOMATION LOCALLY
      // setAutomations(prev =>
      //   prev.map(automation =>
      //     automation.ig_automation_id === ig_automation_id
      //       ? { ...automation, is_active: status }
      //       : automation
      //   )
      // );
      setAutomations(prev => {
        const toggledAutomation = prev.find(
          a => a.ig_automation_id === ig_automation_id
        );

        if (!toggledAutomation) return prev;

        const wasActive = toggledAutomation.is_active;
        const willBeActive = status;

        // update active count safely
        if (wasActive && !willBeActive) {
          setActiveAutomations(p => Math.max(p - 1, 0));
        } else if (!wasActive && willBeActive) {
          setActiveAutomations(p => p + 1);
        }

        // NEW LOGIC
        if (getActiveAutomations && !status) {
          return prev.filter(
            a => a.ig_automation_id !== ig_automation_id
          );
        }

        return prev.map(automaion =>
          automaion.ig_automation_id === ig_automation_id
            ? { ...automaion, is_active: status }
            : automaion
        )
      });
    } else {
      toast.error(response.info);
      // refreshAutomationsList() // rollback if failed
    }
  };

  // const handleTogglePost = async(ig_automation_id: number, ig_automation_post_id: number, status: boolean) => {
  //   const response = await instagramDMAutomationService.igOnOffAutomationPost({
  //     account_id: props.UserReducer.account_id,
  //     influencer_id: props.UserReducer.influencer_id,
  //     user_id: props.UserReducer.user_id,
  //     brand_id: props.UserReducer.brand_id || 0,
  //     user_type: 'Influencer',
  //     ig_automation_id: ig_automation_id,
  //     ig_automation_post_id: ig_automation_post_id,
  //     is_active: status,
  //   });
  //   if (response.status === gtUtil.Constants.SUCCESS) {
  //     toast.success(response.info);
  //     // refreshAutomationsList() // sync with server data
  //     // UPDATE ONLY THE TOGGLED POST LOCALLY
  //     setAutomations(prev =>
  //       prev.map(automation => {
  //         if (automation.ig_automation_id !== ig_automation_id) {
  //           return automation;
  //         }

  //         return {
  //           ...automation,
  //           automation_posts_data: automation.automation_posts_data.map(post =>
  //             post.ig_automation_post_id === ig_automation_post_id
  //               ? { ...post, is_active: status }
  //               : post
  //           ),
  //         };
  //       })
  //     );
  //   } else {
  //     toast.error(response.info);
  //     // refreshAutomationsList() // rollback if failed
  //   }
  // };

  const handleTogglePost = async (
    ig_automation_id: number,
    ig_automation_post_id: number,
    status: boolean
  ): Promise<boolean> => {
    try {
      const response =
        await instagramDMAutomationService.igOnOffAutomationPost({
          account_id: props.UserReducer.account_id,
          influencer_id: props.UserReducer.influencer_id,
          user_id: props.UserReducer.user_id,
          brand_id: props.UserReducer.brand_id || 0,
          user_type: 'Influencer',
          ig_automation_id,
          ig_automation_post_id,
          is_active: status,
        });

      if (response.status === gtUtil.Constants.SUCCESS) {
        toast.success(response.info);

        // update ONLY the toggled post locally
        setAutomations(prev =>
          prev.map(automation => {
            if (automation.ig_automation_id !== ig_automation_id) {
              return automation;
            }

            return {
              ...automation,
              automation_posts_data: automation.automation_posts_data.map(post =>
                post.ig_automation_post_id === ig_automation_post_id
                  ? { ...post, is_active: status }
                  : post
              ),
            };
          })
        );

        return true;
      } else {
        toast.error(response.info);
        return false;
      }
    } catch (error) {
      console.error("Toggle automation post error:", error);
      toast.error("Something went wrong");
      return false;
    }
  };

  async function getIgAutomationsList(currentPage: number = 1, getActiveAutomations: boolean = false) {
    // if (isLoading || !hasMore) return;
    if (isLoading) return;
    try {
      // props.loading(true);
      setIsLoading(true);

      // const currentPage = refresh ? 1 : page;

      const res = await instagramDMAutomationService.getIgAutomationsList({
        account_id: props.UserReducer.account_id,
        influencer_id: props.UserReducer.influencer_id,
        user_id: props.UserReducer.user_id,
        brand_id: props.UserReducer.brand_id || 0,
        user_type: "Influencer",
        page: currentPage,
        limit: LIMIT,
        getActiveAutomations: getActiveAutomations,
      });

      if (res.status === gtUtil.Constants.SUCCESS && Array.isArray(res.data?.rows)) {
        // setAutomations(res.data.rows);
        setAutomations(prev => [...prev, ...res.data.rows]);

        setTotalAutomations(res.data.rows[0].total_automation);
        setActiveAutomations(res.data.rows[0].active_automation);
        // setTotalPosts(res.data.rows[0].total_post);
        // Pagination logic
        if (res.data.rows.length < LIMIT) {
          setHasMore(false); // stop pagination
        } 
        else if (res.data.rows[0].total_automation <= LIMIT) {
          setHasMore(false); // stop pagination
        }
        else {
          setPage(prev => prev + 1);
        }
      } else if (res.status === gtUtil.Constants.DB_QUERY_NO_RECORD_FOUND) {
        // setAutomations([]);
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching IG Automations:", error);
    } finally {
      props.loading(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!hasMore || isLoading) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          getIgAutomationsList(page, showActiveOnly);
        }
      },
      { threshold: 0.5 }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  });

  // const postsWithMeta: PostWithAutomationMeta[] = automations.flatMap((auto) =>
  //   auto.automation_posts_data?.map((post) => ({
  //     ...post,
  //     ig_automation_id: auto.ig_automation_id,
  //     automation_name: auto.automation_name,
  //     keywords: auto.automation_rules_data.flatMap((r) => r.keywords),
  //   }))
  // );

  // const [posts, setPosts] = useState<PostWithAutomationMeta[]>(postsWithMeta);

  // useEffect(() => {
  //   // setPosts(automations.flatMap((auto) => auto.automation_posts_data));
  //   setPosts(automations.flatMap((auto) =>
  //     auto.automation_posts_data?.map((post) => ({
  //       ...post,
  //       ig_automation_id: auto.ig_automation_id,
  //       automation_name: auto.automation_name,
  //       keywords: auto.automation_rules_data.flatMap((r) => r.keywords),
  //     }))
  //   ))
  // }, [automations]);

  // useEffect(() => {
  //   setPosts(
  //     automations.flatMap((auto) => {
  //       if (!auto.automation_posts_data?.length) {
  //         return []; // safely skip automations without posts
  //       }

  //       return auto.automation_posts_data.map((post) => ({
  //         ...post,
  //         ig_automation_id: auto.ig_automation_id,
  //         automation_name: auto.automation_name,
  //         keywords: auto.automation_rules_data?.flatMap((r) => r.keywords) ?? [],
  //       }));
  //     })
  //   );
  // }, [automations]);

  const handleCreateAutomation = () => {
    // handleClosePopUps();
    
    // Added rest of the closePopUps logic here
    setPopUps({
      openConnectInstagram: false,
      openAdditionalSettingsModal: false,
      openPermissionMissingModal: false,
      openAutomationDeleteConfirmation: false,
      openPostDeleteConfirmation: false,
      openUpgradeToAddMoreModal: false,
    });

    setEditingAutomation(null);
    setShowWizard(true);
  };

  const handleEditAutomation = (automation: ExistingIgAutomation) => {
    setEditingAutomation(automation);
    setShowWizard(true);
  };

  const handleCloseWizard = () => {
    setContentType(null);
    setScope(null);

    setShowWizard(false);
    setEditingAutomation(null);
  };

  // previous logic for handling Instagram connection and permissions
  const [instagramAccount, setInstagramAccount] = useState<any>([]);

  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [connectedAccount, setConnectedAccount] = useState<string>('@your_business_account');
  const [connectingInstagram, setConnectingInstagram] = useState(false); 

  const [instagramAllPermissions, setInstagramAllPermissions] = useState<boolean>(false);
  // const [loading, setLoading] = useState(false);
  // const [social_loader, set_social_loader] = useState<boolean>(false);
  const [stateToUpdateUserReducer, setStateToUpdateUserReducer] = useState<boolean>(false);
  const [ig_data, set_ig_data] = useState({});

  const [socialRestrictionPopup, set_socialRestrictionPopup] = useState({
    // youtube: false,
    instagram: false
  });

  function handleClosePopUps() {
    setContentType(null);
    setScope(null);

    setDeleteAutomationLoading(false);
    setPopUps({
      openConnectInstagram: false,
      openAdditionalSettingsModal: false,
      openPermissionMissingModal: false,
      openAutomationDeleteConfirmation: false,
      openPostDeleteConfirmation: false,
      openUpgradeToAddMoreModal: false,
    });
    setConnectingInstagram(false);
  }

  function handleOpenUpgradePopup(upgradeContent: React.ReactNode) {
    setUpgradeToAddMoreModalContent(upgradeContent);

    setPopUps({...popUps, openUpgradeToAddMoreModal: true});
  }

  //Function to check all instagram permission are true or not
  function checkInstagramBusinessPermissions(data: any) {
    let response = false;
    try {
      // Check if all required properties are true
      const instgramPermissions = 
      JSON.parse(data?.instagram_business_basic) && JSON.parse(data?.instagram_business_manage_messages) && JSON.parse(data?.instagram_business_manage_comments) && JSON.parse(data?.webhook_comments) && JSON.parse(data?.webhook_messages) && JSON.parse(data?.webhook_messaging_postbacks)
      // JSON.parse(data?.instagram_business_basic) && JSON.parse(data?.instagram_business_manage_comments)
      ? true
      : false;
      // const instgramPermissions = 
      // JSON.parse(data?.instagram_business_basic)
      // ? true
      // : false;
      if (instgramPermissions) {
        setIsConnected(true);
        setInstagramAllPermissions(true);
        response = true;
      } else {
        setIsConnected(false);
        setInstagramAllPermissions(false);
      }
    } catch (error) {
      console.log('error', error);
      setInstagramAllPermissions(false);
    } finally {
      return response;
    }
  }

  // Get all accounts of the influencer
  async function getInfluencerAccounts() {
    try {
      props.loading(true);
      const res = await instagramDMAutomationService.getInfluencerAccounts({
        influencer_id: props.UserReducer.influencer_id,
      });

      if (res.status === gtUtil.Constants.SUCCESS) {
        // Check permissions only if accounts are present
        if (res.data.rows.length > 0) {
          setInstagramAccount(res.data.rows);
          setConnectedAccount('@' + res?.data?.rows[0]?.username);
          const response = await checkInstagramBusinessPermissions(res.data.rows[0]);

          // if (response) {
          //   setInstagramAccount(res.data.rows);
          //   setInstagramAllPermissions(true);
          // } else {
          //   setInstagramAccount(res.data.rows);
          //   setInstagramAllPermissions(false);
          // }

          // ZAP Live is generally available now, so the internal-handles allowlist is gone.
          // OLD (beta gate). Note it also crashed the Zap screen whenever the env row was
          // missing: `env?.` is optional-chained but `.INTERNAL_IG_HANDLES.split` is not.
          // if (props.UserReducer?.env?.INTERNAL_IG_HANDLES.split(',').includes(res?.data?.rows[0]?.username)) {
          //   setDisableLive(false);
          // } else {
          //   setDisableLive(true);
          // }
        } else {
          setInstagramAccount([]);
        }
      }
    } catch (error) {
      console.error("Error fetching getInfluencerAccounts:", error);
    } finally {
      props.loading(false);
    }
  }

  // Get active Subscription Plan
  async function getCurrentPlan() {
    try {
      props.loading(true);
      const res = await subscriptionService.getCurrentPlan({
        "account_id": props.UserReducer.account_id,
        "influencer_id": props.UserReducer.influencer_id,
        "user_id": props.UserReducer.user_id,
        "brand_id": 0,
        "user_type": "Influencer"
      });

      if (res.status === gtUtil.Constants.SUCCESS) {
        // Check permissions only if accounts are present
        if (res.data) {
          setCurrentPlan(res.data);
          setTotalActiveAutomationPosts(res.data?.utilizedInteractions ? res.data.utilizedInteractions.total_active_automation_posts : 0);
          // OLD (pre-unlimited): the ternary relied on truthiness — kept working for -1
          // but was ambiguous; `?? 0` makes the -1 "Unlimited" sentinel pass through explicitly.
          // setMaxActiveAutomationPosts(res.data.entitlements?.max_active_automation_posts ? res.data.entitlements.max_active_automation_posts : 0);
          setMaxActiveAutomationPosts(res.data.entitlements?.max_active_automation_posts ?? 0);
          // if (res.data.isBasicUser) {
          //   setCurrentPlanName('Basic');
          // } else if (res.data.plan.plan_type === 'Monthly') {
          //   setCurrentPlanName('Pro Plan - Monthly');
          // } else if (res.data.plan.plan_type === 'Annual Plan') {
          //   setCurrentPlanName('Pro Plan - Yearly');
          // } else {
            setCurrentPlanName(`${res.data.plan.plan_name}`);
          // }
        } else {
          setCurrentPlan(null);
        }
      }
    } catch (error) {
      console.error("Error fetching getCurrentPlan in Tools:", error);
    } finally {
      props.loading(false);
    }
  }

  const handleOpenConnectInstagramModal = (selectedContentType: AutomationContentType) => {
    if (!gtUtil.isContentTypeAllowed(currentPlan?.entitlements, selectedContentType || '')) {
      // OLD: showed an upgrade popup the creator then had to act on.
      // handleOpenUpgradePopup("Upgrade to enable automation for this content type.");
      // Now mirrors the Zap hub's locked cards (ZapHub.handleCardClick): a locked
      // ZAP Story / ZAP Live card goes straight to the subscription screen.
      navigate(subscriptionPath);
      return;
    }
    // The plan's active-automation cap, checked HERE rather than at the posts
    // step. It used to fire only once the creator had picked a goal, answered
    // the follow question and started selecting posts — and closing the popup
    // threw all of that away. Nothing is lost if we catch it on the click that
    // would have opened the wizard.
    if (gtUtil.isLimitReached(totalActiveAutomationPosts, maxActiveAutomationPosts)) {
      setPendingContentType(selectedContentType);
      setPlanLimitOpen(true);
      return;
    }

    // console.log('selectedContentType', selectedContentType);
    setContentType(selectedContentType);
    setScope(selectedContentType === 'live' ? 'all' : 'multiple');

    if (instagramAccount?.length < 1) {
      setPopUps({...popUps, openConnectInstagram: true});
    } else if (!instagramAllPermissions) {
      setPopUps({...popUps, openPermissionMissingModal: true});
    } else {
      /* OLD: a creator with a fully connected, fully permissioned account still
         had to read and dismiss the "Important Instagram Setting" popup before
         every single Zap.
         setPopUps({...popUps, openAdditionalSettingsModal: true});

         checkInstagramBusinessPermissions has already confirmed
         instagram_business_basic, manage_messages, manage_comments and all three
         webhook subscriptions through the API, so by this branch there is
         nothing left to ask about — the popup was asking a question we had
         already answered.

         The one thing the API genuinely cannot see is the in-app "Allow access
         to Messages" toggle (Connected Tools): it is an Instagram account
         setting, not an OAuth scope, so it appears in none of those fields.
         That is now a standing note under My Zaps > Settings > Requirements
         rather than a gate on every creation. */
      handleCreateAutomation();
    }
  }

  const instagramConnect = async () => {
    if (connectingInstagram) return;
    try {
      setConnectingInstagram(true);
      const response = await handlesService.instagramConnect();
  
      if (response.status === gtUtil.Constants.SUCCESS) {
        // Open Instagram OAuth in a popup window
        const popup = window.open(
          response.data.url,
          "InstagramOAuthPopup",
          "width=500,height=600,left=100,top=100"
        );
  
        if (!popup) {
          toast.error("Popup blocked. Please allow popups and try again.");
          return;
        }
  
        const channel = new BroadcastChannel('oauth-channel');
        channel.onmessage = async (event) => {
          if (event.data?.type === 'social-auth-success') {
            const authCode = event.data.code;
            channel.close();
  
            try {
              // set_social_loader(true);
              setConnectingInstagram(true);

              // Send auth code to backend
              const response = await handlesService.postInstagramConnect({
                code: authCode,
                influencer_id: props?.UserReducer?.influencer_id
              });
  
              if (response.status === gtUtil.Constants.SUCCESS) {
                updateUserReducer();
                // set_social_loader(false);
                getInfluencerAccounts();
                handleClosePopUps();
                // setPopUps({...popUps, openAdditionalSettingsModal: true});
                toast.success(response.info);
                setConnectingInstagram(false);
              } else {
                if (response.info === 'Social account already connected to the other account.' || response.info === 'Instagram account must be the same as Facebook.') {
                  set_ig_data(response.data);
                  set_socialRestrictionPopup(prevState => ({
                    ...prevState,
                    instagram: true
                  }));
                  toast.error(response.info);
                } else {
                  toast.error('Something went wrong. Please try again.');
                }
                setConnectingInstagram(false);
              }
            } catch (error) {
              setConnectingInstagram(false);
              console.error("Error processing Instagram auth response:", error);
              toast.error("Instagram authentication failed.");
            }
          }
        };
      } else {
        setConnectingInstagram(false);
        console.error("Error fetching Instagram OAuth URL:", response.info);
        toast.error("Failed to get Instagram authentication URL.");
      }
    } catch (error) {
      setConnectingInstagram(false);
      console.error("Instagram Login Error:", error);
      toast.error("Instagram login failed");
    }
  };

  async function updateUserReducer() {
    let latestUserReducerData = await userService.getUpdatedUserReducer(props.UserReducer);
    if (![undefined, null, ''].includes(latestUserReducerData)) {
      props.updateUser(latestUserReducerData)
    }
    setStateToUpdateUserReducer(!stateToUpdateUserReducer);
  }

  const refreshAutomationsList = async (getActiveAutomations: boolean = false) => {
    setAutomations([]);
    setTotalAutomations(0);
    setActiveAutomations(0);
    setPage(1);
    setHasMore(true);
    getIgAutomationsList(1, getActiveAutomations);
  };

  // useEffect(() => {
  //   refreshAutomationsList();
  // }, []);
  useBodyClass('zap-page')
  useEffect(() => {
    if (['automations'].includes(activeTab)) {
      if (showActiveOnly) {
        refreshAutomationsList(showActiveOnly);
      } else {
        refreshAutomationsList();
      }
      // refreshAutomationsList();
    }
  }, [activeTab, showActiveOnly]);

  // useEffect(() => {
  //   getInfluencerAccounts();
  //   // getIgAutomations();
  // }, [props.UserReducer.influencer_id]);

  useEffect(() => {
    getInfluencerAccounts();

    // setShowZaps(false);
    setContentType(null);
    setScope(null);
  }, [props.UserReducer.influencer_id]);
  const handleHowItWorksModalClose = () => {
      setHowItWorksModalVisible(false)
    }
    const handleHowItWorksModalOpen = () => {
      setHowItWorksModalVisible(true)
    }
  // useEffect(() => {
  //   const tabFromUrl = searchParams.get("activeTab");

  //   if (tabFromUrl && ["automations", "activity", "settings"].includes(tabFromUrl)) {
  //     setActiveTab(tabFromUrl);
  //   }
  // }, [searchParams]);

  useEffect(() => {
    getCurrentPlan();
  }, []);

  return (
    <>
      <ZapMobileHeader title="Zap Automations" backRoute={zapBackPath} />
      <div className="container mx-auto lg:p-6 max-w-7xl">
        <div className="mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
            <div className="flex lg:items-center gap-2 lg:gap-3">
              {/* Back to the Zap hub. ZapMobileHeader already provides this, but it is
                  `display: xs only`, so on desktop there was no way back to /influencer/zap
                  short of the top nav. Hidden below `md` to avoid doubling up with it. */}
              <div
                onClick={() => navigate(zapBackPath)}
                title="Back to Zap"
                aria-label="Back to Zap"
                role="button"
                className="d-none d-md-flex items-center justify-center transition-all cursor-pointer hover:bg-gray-50"
                style={{ borderRadius: '50%', width: '36px', height: '36px', alignSelf: 'center', flexShrink: 0 }}
              >
                <ChevronLeft className="w-5 h-5 text-[#111]" />
              </div>
              <div className=' border transition-all border-gray-200' style={{ borderRadius: '10px',width:'70px', height:'60px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                   <img src={zapIconActive} alt="Zap Logo" width={20} height={20} />
                </div>
              <div className='container px-0 px-md-3'>
                <div className='d-flex'>
                  <div>
                    <h1 className='text-[20px] lg:text-[24px]'>Zap Automations</h1>
                    <span onClick={handleHowItWorksModalOpen} className='fs-12 btn btn-text-link d-md-none'>How it works?</span>
                    {/* <p className="text-gray-600 text-[14px] lg:text-[16px]">Automatically send DMs when users comment with specific keywords</p> */}
                    <p className="text-gray-600 text-[14px] lg:text-[16px] mt-2 d-md-block d-none">Automate and manage Instagram comments and DMs.</p>
                  </div>
                  {currentPlan && (
                    <div className='d-flex d-md-none flex-column ms-auto'>
                      <span className='fs-14'>Current Plan: </span> 
                      <button
                        onClick={() => window.location.href = subscriptionPath}
                        className="btn btn-primary btn-xs fs-14"
                      >
                        {currentPlanName}
                      </button>
                    </div>
                  )}
                  
                </div>
              </div>
            </div>
            <div className="md:ml-auto mt-3 md:mt-0 d-none d-md-flex">
              {/* Current Plan Button to navigate to subscription plan page */}
              {currentPlan && (
                <>
                <span className='fs-14 me-1'>Your Current Plan: </span> <button
                  onClick={() => window.location.href = subscriptionPath}
                  className="btn btn-primary ml-auto btn-xs fs-14"
                >
                  {currentPlanName}
                </button></>
              )}
            </div>  
          </div>
        </div>

        <div className="flex gap-2 mb-3 md:mb-4">
          <button
            className={`border md:border-0 px-4 py-2 w-full md:w-auto rounded-full md:rounded-md text-sm font-medium ${
              topTab === 'create'
                ? 'bg-black text-white'
                : 'bg-gray-100 text-gray-700'
            }`}
            onClick={() => setTopTab('create')}
          >
            Create New Zap
          </button>

          <button
            className={`border md:border-0 px-4 py-2 w-full md:w-auto rounded-full md:rounded-md text-sm font-medium ${
              topTab === 'zaps'
                ? 'bg-black text-white'
                : 'bg-gray-100 text-gray-700'
            }`}
            onClick={() => {
              setActiveTab('automations');
              setTopTab('zaps')
            }}
          >
            My Zaps
          </button>
        </div>

        {topTab === 'create' && (
          <StepScope
            disableLive={disableLive}
            entitlements={currentPlan?.entitlements}
            contentType={contentType}
            setContentType={setContentType}
            setScope={setScope}
            // showZaps={showZaps}
            // setShowZaps={setShowZaps}
            handleOpenConnectInstagramModal={handleOpenConnectInstagramModal}
          />
        )}

        {/* "How to use Zap" — opens the full walkthrough guide in a scrollable popup */}
        {topTab === 'create' && (
          <div className="flex justify-center mt-12 mb-2">
            <button
              type="button"
              onClick={() => setZapTourVisible(true)}
              className="inline-flex items-center gap-2 text-[14px] font-medium text-[#9C52A2] border border-[#e8d3ec] bg-[#faf5fb] hover:bg-[#f3e6f5] rounded-full px-4 py-2 transition"
            >
              <PlayCircle className="w-4 h-4" /> How to use Zap
            </button>
          </div>
        )}

        {/* <Tabs defaultValue="automations" className="space-y-6"> */}
        {topTab === 'zaps' && (
          // <Tabs value={activeTab} onValueChange={setActiveTab}>
          <Tabs
            value={activeTab}
            onValueChange={(value) => {
              if (value === 'automations' || value === 'activity' || value === 'settings') {
                setActiveTab(value);
              }
            }}
          >
            {/* <TabsList className="grid w-full grid-cols-3 max-w-md mb-0"> */}
            <TabsList className="grid w-full grid-cols-3 max-w-md mb-2">
              <TabsTrigger value="automations" className="flex items-center gap-2  text-[12px] lg:text-[14px]">
                {/* <Zap className="w-4 h-4" /> */}
                <img src={zapIconActive} alt="Zap Logo" width={10} height={10} />
                All Zaps
              </TabsTrigger>
              <TabsTrigger value="activity" className="flex items-center gap-2  text-[12px] lg:text-[14px]">
                <Activity className="w-4 h-4" />
                Interactions
              </TabsTrigger>
              <TabsTrigger value="settings" className="flex items-center gap-2  text-[12px] lg:text-[14px]">
                <Settings className="w-4 h-4" />
                Settings
              </TabsTrigger>
            </TabsList>

            <TabsContent value="automations">
              <AutomationList
                automations={automations}
                onEdit={handleEditAutomation}
                // handleOpenConnectInstagramModal={handleOpenConnectInstagramModal}
                handleDeleteAutomation={handleDeleteAutomation}
                handleToggleAutomation={handleToggleAutomation}
                isLoading={isLoading}
                hasMore={hasMore}
                loadMoreRef={loadMoreRef}
                setTopTab={setTopTab}
                showActiveOnly={showActiveOnly}
                setShowActiveOnly={setShowActiveOnly}
                influencerId={props.UserReducer?.influencer_id}
              />
            </TabsContent>

            <TabsContent value="activity">
              <ActivityLog />
            </TabsContent>

            <TabsContent value="settings">
              {/* <AccountSettings 
                // posts={posts} 
                handleTogglePost={handleTogglePost} 
                handleDeletePost={handleDeletePost} 
                // refreshAutomationsList={refreshAutomationsList}
                isLoading={isLoading}
                hasMore={hasMore}
                loadMoreRef={loadMoreRef}
                // total_post={totalPosts}
                getIgAutomationsList={getIgAutomationsList}
                page={page}
              /> */}
              <AccountSettings loading={props.loading} influencerId={props.UserReducer.influencer_id} handleTogglePost={handleTogglePost} handleDeletePost={handleDeletePost} instagramConnect={instagramConnect} connectingInstagram={connectingInstagram} setConnectingInstagram={setConnectingInstagram} isConnected={isConnected} connectedAccount={connectedAccount} currentPlan={currentPlan} onHowToUseZap={() => setZapTourVisible(true)} />

              {/* <AccountSettings handleTogglePost={handleTogglePost} handleDeletePost={handleDeletePost} /> */}
            </TabsContent>
          </Tabs>
        )}

        {/* {showWizard && instagramAccount?.length > 0 && (
          <SetupWizard
            open={showWizard}
            onClose={handleCloseWizard}
            editingAutomation={editingAutomation}
            instagramAccount={instagramAccount}
            UserReducer={props.UserReducer}
            refreshAutomationsList={refreshAutomationsList}
            setEditingAutomation={setEditingAutomation}
            loading={props.loading}
            disableLive={disableLive}
          />
        )} */}

        {showWizard && instagramAccount?.length > 0 && (
          <SetupWizard
            open={showWizard}
            onClose={handleCloseWizard}
            editingAutomation={editingAutomation}
            instagramAccount={instagramAccount}
            UserReducer={props.UserReducer}
            refreshAutomationsList={refreshAutomationsList}
            setEditingAutomation={setEditingAutomation}
            loading={props.loading}
            disableLive={disableLive}
            contentType={contentType}
            scope={scope}
            setTopTab={setTopTab}
            setActiveTab={setActiveTab}

            entitlements={currentPlan?.entitlements || null}
            getCurrentPlan={getCurrentPlan}
            totalActiveAutomationPosts={totalActiveAutomationPosts}
            setTotalActiveAutomationPosts={setTotalActiveAutomationPosts}
            maxActiveAutomationPosts={maxActiveAutomationPosts}
            handleOpenUpgradePopup={handleOpenUpgradePopup}
            currentPlanName={currentPlanName}
            allowOtherSource={allowOtherSource}
          />
        )}
      </div>
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openConnectInstagram}
        modalTitle="Connect Instagram"
        modalContent=""
        // onClose={() => handleClosePopUps()}
        onClose={() => {
          if (!connectingInstagram) handleClosePopUps();
        }}
      >
        { 
          connectingInstagram 
          ?
          <ContentLoading width='150' height='150' /> 
          :
          <div className="popup-content">
            <p>Automation requires a connected account. Connect your Instagram account and set your permissions to use the feature.</p>
            <button className="btn btn-primary" onClick={instagramConnect}>
              Connect
            </button>
          </div>
        }
      </CommonPopUpCentered>
      {/* Kept, but no longer reached from handleOpenConnectInstagramModal — see the
          note there. Left in place so the guidance can be re-enabled from a single
          setPopUps call if Meta ever exposes the Connected Tools toggle. */}
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-medium  mx-auto`}
        openModal={popUps.openAdditionalSettingsModal}
        modalTitle="Important Instagram Setting"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        <div className="popup-content">
          <p className="text-left">It looks like there's one key setting missing from your Instagram account. To enable Automation, please grant access to Instagram Partner messages.</p>
          <div className="text-left">
            <strong>Here’s how to do it:</strong>
            <ol className="">
              <li>Open your Instagram mobile app.</li>
              <li>{`Go to Menu > Settings and activity > Messages and story replies > Message Controls > Connected Tools.`}</li>
              <li>
                {`Toggle ON ‘Allow access to Messages’.`}</li>
            </ol>
          </div>
          <button onClick={handleCreateAutomation} className="btn btn-primary">
            It’s Done!
          </button>
        </div>
      </CommonPopUpCentered>

      {/* <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-medium  mx-auto`}
        openModal={popUps.openUpgradeToAddMoreModal}
        modalTitle="Upgrade"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        <div className="popup-content">
          <p className="text-left">{upgrageToAddMoreModalContent}</p>
          <button 
            onClick={() => {
              handleClosePopUps();
              navigate(subscriptionPath);
            }}
            className="btn btn-primary"
          >
            Upgrade 123
          </button>
        </div>
      </CommonPopUpCentered> */}
      <CommonModalClosable
        open={popUps.openUpgradeToAddMoreModal}
        title=""
        onClose={handleClosePopUps}
      >
        <div className="flex flex-col items-center text-center gap-4 py-2">
          {/* Icon header */}
          <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #833ab4 0%, #e1306c 50%, #fcaf45 100%)' }}>
            <Zap className="w-8 h-8 text-white fill-white" />
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Unlock More Power</h3>
            <p className="text-sm text-gray-500">You've reached your plan limit</p>
          </div>

          {/* Message */}
          <div className="w-full bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm text-amber-800 text-left">
            {upgrageToAddMoreModalContent}
          </div>

          {/* Feature highlights */}
          <div className="w-full bg-gray-50 rounded-xl p-4 text-left space-y-3">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide">What you unlock with upgrade</p>
            {/* Copy lives in upgradeBenefits.ts, shared with mobile, and every
                line is checked against plan_entitlements — see the note there.
                OLD: an inline list written in model vocabulary ("rules",
                "variations", "product links (Zap) per rule") — the exact words
                the simplified wizard stopped using — whose last line promised
                "Advanced analytics & activity logs", which no entitlement
                backs. */}
            {UPGRADE_BENEFITS.map((benefit) => (
              <div key={benefit} className="flex items-center gap-3 text-sm text-gray-700">
                <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" />
                <span>{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTA */}
          <button
            onClick={() => {
              handleClosePopUps();
              navigate(subscriptionPath);
            }}
            className="w-full text-white rounded-xl py-3 font-semibold text-sm transition hover:opacity-90 active:scale-95"
            style={{ background: 'linear-gradient(135deg, #833ab4 0%, #e1306c 50%, #fcaf45 100%)' }}
          >
            Upgrade Now
          </button>
        </div>
      </CommonModalClosable>

      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openPermissionMissingModal}
        modalTitle="Permissions Missing"
        modalContent=""
        // onClose={() => handleClosePopUps()}
        onClose={() => {
          if (!connectingInstagram) {
            handleClosePopUps();
          }
        }}
      >
        { 
          connectingInstagram 
          ?
          <ContentLoading width='150' height='150' /> 
          :
          <div className="popup-content">
            <p>It looks like a few permissions are missing. Please either reconnect your account or add new one to proceed.</p>          
            <button className="btn btn-primary" onClick={instagramConnect}>Connect</button>
            <p className="mt-4"><strong>Note:</strong> Connecting a new account will disconnect your currently linked account <strong>{instagramAccount[0]?.username ? instagramAccount[0]?.username : '' }</strong> and set the new account as your primary account.</p>
          </div>
        }
      </CommonPopUpCentered>

      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openAutomationDeleteConfirmation}
        modalTitle="Confirm"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        {
          <div className="popup-content">
            <p>Are you sure you want to delete Automation <strong>{selectedAutomation.automation_name}</strong>.</p>          
            <button className="btn btn-primary" onClick={() => deleteAutomation(selectedAutomation.ig_automation_id)}>
              {deleteAutomationLoading ? 'Deleting' : 'Delete'}
            </button>
          </div>
        }
      </CommonPopUpCentered>

      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openPostDeleteConfirmation}
        modalTitle="Confirm"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        {
          <div className="popup-content">
            <p>Are you sure you want to delete <strong>{selectedPost.automation_name}</strong>'s Post.</p> 
            {Boolean(selectedPost.gcp_media_file_url) && (
              <div className="post-preview mb-3">
                <img
                  src={selectedPost.gcp_media_file_url}
                  alt="Post preview"
                  className="img-fluid rounded"
                />
              </div>
            )}         
            <button className="btn btn-primary" onClick={() => deleteAutomationPost(selectedPost.ig_automation_id, selectedPost.ig_automation_post_id)}>
              {deleteAutomationLoading ? 'Deleting' : 'Delete'}
            </button>
          </div>
        }
      </CommonPopUpCentered>
      <MobileConfirmPopup
  open={howItWorksModalVisible}
  onClose={handleHowItWorksModalClose}
  title="Steps for DM automation"
  onConfirm={()=>{}}
  align='bottom'
  confirmText=""
  cancelText="Cancel"
  description={
    <div className="flex flex-col text-left pt-3">
      <p>
        <span className="font-semibold">1.</span>{' '}
        Tap <span className="font-semibold">New</span> to create an automation
      </p>

      <p>
        <span className="font-semibold">2.</span>{' '}
        Select the post you want automation on
      </p>

      <p>
        <span className="font-semibold">3.</span>{' '}
        Add trigger keywords
        <span className="italic"> (“link”, “details”)</span>
      </p>

      <p>
        <span className="font-semibold">4.</span>{' '}
        Add custom comment + DM replies
      </p>

      <p>
        <span className="font-semibold">5.</span>{' '}
        Tap on <span className="font-semibold">Go Live</span> — and
        you’re live
      </p>
    </div>
  }
/>
      <ZapTourModal open={zapTourVisible} onClose={() => setZapTourVisible(false)} entitlements={currentPlan?.entitlements || null} />

      {/* Plan limit, caught before the wizard opens. Offers the two free ways
          out — pause a running Zap right here, or go review them in My Zaps —
          alongside Upgrade. */}
      <PlanLimitModal
        open={planLimitOpen}
        used={totalActiveAutomationPosts}
        limit={maxActiveAutomationPosts}
        automations={automations}
        currentPlanName={currentPlanName}
        onTogglePause={async (ig_automation_id: number, nextActive: boolean) => {
          const ok = await handleToggleAutomation(ig_automation_id, nextActive);
          // handleToggleAutomation keeps its own counters; the cap is measured
          // in active POSTS, which only the plan endpoint knows, so re-read it.
          await getCurrentPlan();
          return ok;
        }}
        onGoToMyZaps={() => {
          setPlanLimitOpen(false);
          setTopTab('zaps');
          setActiveTab('automations');
        }}
        onContinue={() => {
          setPlanLimitOpen(false);
          const type = pendingContentType;
          setPendingContentType(null);
          if (type) handleOpenConnectInstagramModal(type);
        }}
        onUpgrade={() => {
          setPlanLimitOpen(false);
          navigate(subscriptionPath);
        }}
        onClose={() => {
          setPlanLimitOpen(false);
          setPendingContentType(null);
        }}
      />
    </>
  );
}

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClanZap);

export { connectToRedux as ClanZap };